export enum EventType {
  ServiceUnavailable = 'ServiceUnavailable',
}

interface EventPayload {
  [EventType.ServiceUnavailable]: undefined;
}

type Listeners = {
  [T in EventType]: EventListener<T>[];
};

type EventListener<T extends EventType> = (p?: EventPayload[T]) => void;

export class EventService {
  private static listeners: Listeners = {
    [EventType.ServiceUnavailable]: [],
  };

  static emit<T extends EventType>(name: T, params?: EventPayload[T]) {
    (this.listeners[name] || []).forEach(listener => listener(params));
  }

  static addEventListener<T extends EventType>(eventName: T, listener: EventListener<T>) {
    (this.listeners[eventName] as EventListener<T>[]).push(listener);
    return () => {
      this.removeEventListener(eventName, listener);
    };
  }

  private static removeEventListener<T extends EventType>(eventName: T, listener: EventListener<T>) {
    (this.listeners[eventName] as EventListener<T>[]).splice(
      (this.listeners[eventName] as EventListener<T>[]).indexOf(listener),
      1,
    );
  }
}
